<script lang="ts">
    export let word: string
</script>

<h2>{word}</h2>

<p>
    Quel est le degré de concrétude du mot <span class="capitalized">{word}</span>?
</p>

<style>
    .capitalized {
        text-transform: uppercase;
    }
</style>